{
  "title": "Connecter mon application mobile",
  "form": {
    "mobileApp": {
      "label": "Sélectionnez l'application de votre choix pour générer le QR code",
      "placeholder": "Sélectionnez une application",
      "validation": {
        "required": "Vous devez sélectionner une application mobile"
      }
    },
    "button": {
      "content": "Générer le QR code"
    }
  },
  "qrCode": {
    "expirationDate": "Expire le"
  },
  "downloadOfflineAccess": {
    "button": "Télécharger ma configuration hors-ligne"
  },
  "passwordModal": {
    "password": {
      "validation": {
        "pattern": "Le mot de passe doit être composé d'au moins 12 caractères, dont des lettres majuscules et minuscules, des chiffres et des caractères spéciaux",
        "required": "Vous devez saisir un mot de passe"
      },
      "label": "Mot de passe"
    },
    "title": "Saisir le mot de passe fourni par l'application My LogUp"
  }
}
